import React from 'react';
import { Observer } from 'mobx-react';
import { observable } from 'mobx';
import cookie from 'js-cookie';

import { setDefaultLocale } from './actions';
import deCH from './resources/deCH';
import enUS from './resources/enUS';
import frCH from './resources/frCH';
import csCZ from './resources/csCZ';

const RESOURCES = {
  'de-CH': deCH,
  'en-US': enUS,
  'fr-CH': frCH,
  'cs-CZ': csCZ
}

console.log('translate init')

let highlighted = parseInt(window.localStorage.getItem('highlightTranslations'));

let translations;


function fillVars(str, vars) {
  for (let k in vars) {
    str = str.replace(`\${${k}}`, vars[k] || '');
  }
  return str;
}

function promptTranslation(event, id, defaultValue, vars, binding, boundId) {
  if (event.ctrlKey || event.shiftKey || event.altKey) {
    event.stopPropagation();
    let dlg = `
      Changing translation:
        ID: ${id}
        BOUND_ID: ${boundId}
        defaultValue: ${defaultValue}
        currentVars: ${JSON.stringify(vars)}
    `
    let defVal;
    defVal = translations &&
      translations[binding] &&
      translations[binding][boundId] &&
      translations[binding][boundId][id] &&
      translations[binding][boundId][id].value ||
      defaultValue;
    let newValue = window.prompt(dlg, defVal)
    if (newValue !== null) {
      try {
        translations[binding][boundId][id].value = newValue;
        window.localStorage.setItem('translations', JSON.stringify(translations, null, 2));
      } catch (e) {
        window.alert('Could not set the resource:' + e);
      }
    }
  }
}

class Translator {
  constructor(context) {
    this.context = context || {};
    this.translate.bindPage = this.bindPage;
    this.translate.bindComponent = this.bindComponent;
  }

  translate = (id, defaultValue, vars, stringOnly) => {
    let value = defaultValue;
    let binding = 'unbound';
    let boundId;
    if (this.context.pageId) {
      binding = 'pages';
      boundId = this.context.pageId
    }
    if (this.context.componentId) {
      binding = 'components';
      boundId = this.context.componentId;
    }
    let translated = false;
    if (translations &&
      translations[binding] &&
      translations[binding][boundId] &&
      translations[binding][boundId][id] &&
      translations[binding][boundId][id].value
    ) {
      translated = true;
      value = translations[binding][boundId][id].value;
    }
    let filledValue = fillVars(value, vars);
    if (highlighted && !stringOnly) {
      return <Observer>{() => <span
        onClick={(event) => promptTranslation(event, id, defaultValue, vars, binding, boundId)}
        className={"translations-highlight" + (translated ? "-translated" : "")}
        title={`ID: ${id}\nLOC_PAGE_ID: ${this.context.pageId}\nLOC_COMPONENT_ID: ${this.context.componentId}`}>
        {filledValue}
      </span>}</Observer>;
    } else {
      return filledValue;
    }
  }

  bindPage = (id, name) => {
    return new Translator({
      ...this.context,
      pageId: id,
      pageName: name,
    }).translate
  }

  bindComponent = (id, name) => {
    return new Translator({
      ...this.context,
      componentId: id,
      componentName: name,
    }).translate
  }


}


const translator = new Translator();

const events = {
  onTranslationsInited: undefined,
};

export function initTranslations() {
  // Hack to eliminate the double language cookie problem (#10599)
  /*
  console.log(document.cookie)
  let splCookie = document.cookie ? document.cookie.split('; ') : [];
  let splCookieParts = splCookie.map(o => o.split("="));
  let asapLanguageCnt = 0;
  for(let i = 0; i < splCookieParts.length; i++) {
    let [partKey, partValue] = splCookieParts[i];
    console.log(partKey)
  }*/

  // cookie.remove('asapLanguage', {path: '/'});
  // cookie.remove('asapCurrentLocale', {path: '/'});

  setDefaultLocale();

  if (highlighted) {
    translations = observable(JSON.parse(window.localStorage.getItem('translations')));
  } else if (window.localStorage.getItem('translations')) {
    translations = JSON.parse(window.localStorage.getItem('translations'));
  } else {
    translations = RESOURCES[cookie.get('origamLanguage') || 'de-CH'];
  }
  events.onTranslationsInited && events.onTranslationsInited();
}

export default translator.translate;
export {
  events,
}



// WEBPACK FOOTER //
// ./src/translate/index.js